import { type LDFlagValue } from 'launchdarkly-js-client-sdk';

// Add new feature flags to this const
export const FEATURE_FLAG = {
  aiVisibility: 'aiVisibility',
} as const;

export type FEATURE_FLAG = keyof typeof FEATURE_FLAG;

export type FEATURE_FLAG_VALUE = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

export type C99FlagSet = Record<FEATURE_FLAG_VALUE, LDFlagValue>;
